export default class Stock {
    constructor(symbol,fullName){
        this.fullName = fullName;
        this.symbol = symbol;
        this.data = [];
  
    }

    addData(date,high,low,open,close,vol){
        var stockdata =new StockData(date,high,low,open,close,vol);
        if(stockdata.date > 0){
        this.data.push(stockdata);
        }
    }
    sort(){
        this.data.sort(function(a,b){
         return a.date - b.date;
});
    }

    isStockData(){
        return true;
    }

    getData(){
        return this.data.slice(0);
    }

    asArray(){
       return  this.getData();
    }
    getFullName(){
        return this.fullName;
    }

    getStartDate(){
        return new Date(Math.max.apply(null, this.data.map(function(e) {
            return new Date(e.date);
          })));
    }
    getEndDate(){
        return new Date(Math.min.apply(null, this.data.map(function(e) {
            return new Date(e.date);
          })));
    }
}
export class StockData{
    constructor(date,high,low,open,close,vol){
        this.dateStr = date;
        this.date = Date.parse(date);
        this.high = +high;
        this.low = +low;
        this.open = +open;
        this.close = +close;
        this.vol = +vol;
    }
}